<script setup lang="ts">
import { PropType, defineProps, ref } from "vue";
import ModalBox from "@/components/v2/Modal/ModalBox.vue";
import { useTasksStore } from "@/stores/v2";

// Store
const tasksStore = useTasksStore();
// Props
defineProps({
  showModal: {
    type: Boolean,
    default: false,
  },
  toggleCommentsModal: {
    type: Function as PropType<(payload: MouseEvent) => void>,
    required: true,
  },
});
// State
const comment = ref("");

const addCommentOnTask = () => {
  if (tasksStore.activeTask) {
    tasksStore.activeTask.comment = comment.value;
  }
};
</script>

<template>
  <ModalBox v-if="showModal" @close="toggleCommentsModal">
    <template #header> Leave a comment </template>
    <template #main>
      <textarea class="w-full h-28 rouned resize-none p-2 outline-secondary border border-gray-400" v-model="comment"
        @input="addCommentOnTask"></textarea>
    </template>
    <template #footer>
      <button @click="toggleCommentsModal" type="button"
        class="text-white bg-primary focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover: focus:z-10">
        Save
      </button>
      <button @click="toggleCommentsModal" type="button"
        class="text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10">
        Close
      </button>
    </template>
  </ModalBox>
</template>
